import React from 'react'
import { Link } from 'react-router-dom'
import Card, { CardContent } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  noteList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: theme.spacing.unit
  },
  card: {
    marginBottom: 2 * theme.spacing.unit,
    marginLeft: 2 * theme.spacing.unit,
    marginRight: 2 * theme.spacing.unit,
    maxWidth: '100%',
    width: 400
  },
  cardContent: { paddingBottom: 2 * theme.spacing.unit + 'px !important' },
  encryptedNoteTitle: {
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    fontStyle: 'italic'
  },
  decryptedNoteTitle: {
    textDecoration: 'none'
  }
})

function renderNoteItem(key, note, classes) {
  return (
    <Card key={key} className={classes.card}>
      <CardContent className={classes.cardContent}>
        {note ? (
          <Typography
            type="body1"
            component={Link}
            to={`/notes/${key}`}
            className={classes.decryptedNoteTitle}
          >
            {note.title || 'Untitled note'}
          </Typography>
        ) : (
          <Typography
            type="body1"
            component={Link}
            to={`/notes/${key}`}
            className={classes.encryptedNoteTitle}
          >
            Encrypted note
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}

export default withStyles(
  styles
)(({ encryptedNotes, decryptedNotes, classes }) => {
  return (
    <div className={classes.noteList}>
      {Object.keys(encryptedNotes).map(key =>
        renderNoteItem(key, decryptedNotes[key], classes)
      )}
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/components/NoteList.js